import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import { dossierResponseSchema, type Dossier } from './types';

interface Options {
  /** Empresa activa: entra al queryKey para no servir el expediente cacheado de otra empresa. */
  companyId: string | null;
  /** No dispara hasta conocer la empresa activa (garantiza X-Active-Company en carga fría/deep-link). */
  enabled: boolean;
}

/** Expediente completo de un documento. Valida el contrato con Zod: un drift del
 *  backend cae al estado de error de la query (nunca pantalla blanca). Un 404 llega
 *  como ApiError con status 404, que la pantalla distingue del error genérico. */
export function useDossier(id: string, { companyId, enabled }: Options): UseQueryResult<Dossier> {
  const api = useApi();
  return useQuery({
    queryKey: ['dossier', companyId, id],
    queryFn: async () => {
      const raw = await api.get<unknown>(`/api/v1/quality/master-list/${id}/dossier`);
      return dossierResponseSchema.parse(raw).data;
    },
    enabled,
  });
}
